// extracted by mini-css-extract-plugin
export default {"calendarSmall":"calendarSmall_calendarSmall__TBy2s"};